module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_4_2-76a07987eaa2af2ffb95452c0b47607d.png";